
export function getChangedFields<T extends object>(
  updated: T,
  backup: T,
  excludedKeys: (keyof T)[] = []
): Partial<T> {
  const changed: Partial<T> = {};

  for (const key of Object.keys(updated) as (keyof T)[]) {
    if (excludedKeys.includes(key)) continue;

    const updatedVal = updated[key];
    const backupVal = backup[key];

    if (
      typeof updatedVal === 'object' &&
      updatedVal !== null &&
      !Array.isArray(updatedVal) &&
      typeof backupVal === 'object' &&
      backupVal !== null &&
      !Array.isArray(backupVal)
    ) {
      const nested = getChangedFields(
        updatedVal as object,
        backupVal as object
      );
      if (Object.keys(nested).length > 0) {
        changed[key] = nested as T[typeof key];
      }
    } else if (JSON.stringify(updatedVal) !== JSON.stringify(backupVal)) {
      changed[key] = updatedVal;
    }
  }

  return changed;
}
